// Selo "✨ Decorado com IA" no canto superior-esquerdo de uma foto que JÁ é decoração
// aprovada (descricao "decorado com IA") — experiência V2. Discreto, não briga com a
// pílula "Decorar" (que fica no inferior-direito). O clique no SELO (não na foto):
//   • se a foto tem marcador [antes:<id>] e a original está na lista → abre o TEASER
//     com o par real (via host);
//   • senão → cai no comportamento normal da foto (lightbox), delegando pro onLightbox
//     que a galeria passa.
// Só as galerias decidem renderizá-lo (ativo && v2 && foto decorada). Em V1 nunca aparece.
import React from 'react';
import { abrirTeaser } from './decoradorBus';
import { resolveParReal } from './decoradorFotos';
import styles from './DecorarBadge.module.css';

interface IDecorarBadgeProps {
    // a foto DECORADA (com descricao "decorado com IA")
    foto: any;
    // lista COMPLETA de fotos do imóvel (pra achar a original pelo [antes:id])
    fotos: any[];
    // fallback: abrir o lightbox normal quando não há par real
    onLightbox?: () => void;
}

const DecorarBadge: React.FC<IDecorarBadgeProps> = ({ foto, fotos, onLightbox }) => {
    const onClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        const par = resolveParReal(foto, fotos);
        if (par) {
            abrirTeaser({ antesUrl: par.antesUrl, depoisUrl: par.depoisUrl, estiloNome: par.estiloNome });
            return;
        }
        // sem par real → lightbox normal (mesma ação de clicar na foto)
        onLightbox?.();
    };

    return (
        <button
            type="button"
            className={styles.selo}
            onClick={onClick}
            aria-label="Ver comparação antes e depois desta decoração com IA"
            title="Decorado com IA ✨"
        >
            <span aria-hidden="true">✨</span>
            <span className={styles.label}>Decorado com IA</span>
        </button>
    );
};

export default DecorarBadge;
